module.exports = "<div [ngClass]=\"type\" *ngIf=\"url\" [ngStyle]=\"{ 'background-image': 'url(' + url + ')' }\"></div>"